if (!customElements.get('nss-footer')) {
    customElements.define(
        'nss-footer',
        class NSSFooter extends HTMLElement {
            constructor() {
                super();

                this.toggleSelector = '.js-nss-footer-menu-toggle';
                this.openClass = 'is-open';
            }

            connectedCallback() {
                this.addEventListener('click', (e) => {
                    const toggle = e.target.closest(this.toggleSelector);
                    if (!toggle) return;

                    const isOpen = toggle.classList.contains(this.openClass);

                    this.closeAll();

                    if (!isOpen) {
                        toggle.classList.add(this.openClass);
                        toggle.nextElementSibling?.classList.add(this.openClass);
                    }
                });
            }

            closeAll() {
                this.querySelectorAll(`.${this.openClass}`).forEach((el) => {
                    el.classList.remove(this.openClass);
                });
            }
        }
    );
}
